var r={exports:{}};export{r as t};
//# sourceMappingURL=index6.js.map
